'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _globals = require('../mixins/globals');

var _globals2 = _interopRequireDefault(_globals);

var _Datepicker = require('../components/Datepicker.vue');

var _Datepicker2 = _interopRequireDefault(_Datepicker);

var _UiAlert = require('../material/UiAlert.vue');

var _UiAlert2 = _interopRequireDefault(_UiAlert);

var _UiSelect = require('../material/UiSelect.vue');

var _UiSelect2 = _interopRequireDefault(_UiSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var format = [{ text: 'XLSX', value: 'xlsx' }, { text: 'XLS', value: 'xls' }, { text: 'CSV', value: 'csv' }];
exports.default = {
  name: 'ChartView',
  mixins: [_globals2.default],
  components: {
    DatePicker: _Datepicker2.default,
    UiAlert: _UiAlert2.default,
    UiSelect: _UiSelect2.default
  },
  data: function data() {
    return {
      showChart: false,
      restaurants: [],
      locals: [],
      selectableLocals: [],
      error: {
        status: false,
        messages: ''
      },
      format: format,
      disabledBorn: {
        from: new Date()
      },
      born_start: new Date(),
      born_end: new Date(),
      tempRestaurant: null,
      tempLocal: [],
      localDownloadRequestString: '',
      dateStart: '',
      dateEnd: '',
      responseLocals: false,
      responseRestaurants: false,
      disabledChart: false,
      loadingChart: false,
      timeLimitDay: '',
      timeInitDay: '',
      tempFormat: null,
      flagAlert: false,
      arrayId: '&',
      options: {
        chart: {
          type: 'column'
        },
        title: {
          text: '',
          x: -20 //center
        },
        subtitle: {
          text: '',
          x: -20
        },
        xAxis: {
          categories: ['Detractores', 'Pasivos', 'Promotores']
        },
        yAxis: {
          title: {
            text: 'Cantidad'
          },
          plotLines: [{
            value: 0,
            width: 1,
            color: '#808080'
          }]
        },
        tooltip: {
          valueSuffix: ''
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          borderWidth: 0
        },
        series: []
      }
    };
  },

  computed: {
    setRestaurant: function setRestaurant() {
      for (var i in this.restaurants) {
        if (this.restaurants[i].value == window.localStorage.getItem('restaurante')) {
          this.tempRestaurant = this.restaurants[i];
          this.buildSelectableLocals(this.restaurants[i]);
          return this.tempRestaurant.text;
        }
      }
    }
  },
  watch: {
    'error.status': function errorStatus(val, old) {
      var _this = this;

      if (val) {
        setTimeout(function () {
          _this.error.status = false;
        }, 1600);
      }
    },
    tempRestaurant: function tempRestaurant(val, oldval) {
      if (val !== null && typeof val !== 'undefined') {
        this.buildSelectableLocals(val);
      } else {
        this.flagRestaurant = false;
        this.disabledCreate = false;
      }
    },
    tempLocal: function tempLocal(val, old) {
      if (val !== null) {
        if (val.length > 0) {
          var self = this;
          this.localDownloadRequestString = '';
          val.forEach(function (value, index, array) {
            self.localDownloadRequestString += '&local_id%5B%5D=' + value.value;
          });
          this.flagLocals = true;
        } else {
          this.flagLocals = false;
        }
        this.disabledChart = true;
      } else {
        this.disabledChart = false;
      }
    }
  },
  created: function created() {
    var _d = new Date();
    var _m = _d.getMonth() + 1;
    var _month = _m <= 9 ? '0' + _m : '' + _m;
    this.dateEnd = _d.getFullYear() + '-' + _month + '-' + _d.getDate();
    this.dateStart = _d.getFullYear() + '-' + _month + '-' + _d.getDate();
    this.flagAdmin = this.isCurrentUserAdmin();
    this.fetchLocal();
    this.fetchRestaurant();
  },

  methods: {
    isCurrentUserAdmin: function isCurrentUserAdmin() {
      if (window.localStorage.getItem('role') === 'admin') {
        return true;
      } else {
        return false;
      }
    },
    buildSelectableLocals: function buildSelectableLocals(restaurant) {
      if (this.tempLocal.length != 0) {
        this.tempLocal = [];
      }
      this.selectableLocals = [];
      if (window.localStorage.getItem('local') == 0) {
        for (var i in this.locals) {
          if (this.locals[i].r_id == restaurant.value || this.locals[i].r_id == 0) {
            this.selectableLocals.push(this.locals[i]);
          }
        }
      } else {
        this.selectableLocals = this.locals.filter(function (val, key) {
          return val.r_id == window.localStorage.getItem('restaurante') && val.value == window.localStorage.getItem('local');
        });
      }
    },
    yymmdd: function yymmdd(_date) {
      var mm = _date.getMonth() + 1;
      var dd = _date.getDate();

      return [_date.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-');
    },
    ddmmyy: function ddmmyy(_date) {
      var mm = _date.getMonth() + 1;
      var dd = _date.getDate();

      return [(dd > 9 ? '' : '0') + dd, (mm > 9 ? '' : '0') + mm, _date.getFullYear()].join('-');
    },
    onSelectedDateStart: function onSelectedDateStart(_date) {
      this.dateStart = this.yymmdd(_date);
      this.born_start = _date;
    },
    onSelectedDateEnd: function onSelectedDateEnd(_date) {
      this.dateEnd = this.yymmdd(_date);
      this.born_end = _date;
    },
    initChart: function initChart() {
      this.arrayId = '&';
      this.clearChart();
      this.flagAlert = false;
      this.options.title.text = 'Reporte de NPS';
      this.options.subtitle.text = 'NPS: ';
      var _arr1 = this.dateEnd.split('-');
      var _arr2 = this.dateStart.split('-');
      var date1 = new Date(_arr1);
      var date2 = new Date(_arr2);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      if (diffDays > 31) {
        var _tempDate = this.addDays(_arr2, 31);
        this.timeLimitDay = this.yymmdd(_tempDate);
        this.flagAlert = true;
      } else {
        this.flagAlert = false;
        this.timeLimitDay = this.yymmdd(date1);
      }
      this.onSubmitChart();
    },
    addDays: function addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },
    onSubmitChart: function onSubmitChart() {
      var _this2 = this;

      this.showChart = false;
      var _url = '/admin/stats/nps';
      this.disabledChart = true;
      this.loadingChart = true;
      var _tempLocals = [];
      var _tempRestaurant = [];
      _tempRestaurant.push(+this.tempRestaurant.value);
      var _tempNames = {};
      this.tempLocal.forEach(function (val) {
        _tempLocals.push(val.value);
        _this2.arrayId = _this2.arrayId + 'local_id[]=' + val.value + '&';
        _tempNames[val.text] = [0, 0, 0];
      });
      var _obj = {
        before: this.dateEnd,
        after: this.dateStart,
        local_id: _tempLocals,
        restaurante_id: _tempRestaurant
      };
      this.$http({
        url: _url,
        method: 'GET',
        params: _obj
      }).then(function (response) {
        var date1 = new Date(_this2.timeLimitDay);
        _this2.options.series = [];
        var _data = response.data;
        for (var _key in _data) {
          var _temp = _data[_key];
          var _intDate = parseInt(_key);
          if (_intDate <= date1.getTime()) {
            var _recomendacion = parseInt(_temp.recomendacion);
            if (_recomendacion >= 0 && _recomendacion <= 6) {
              _tempNames[_temp.local_name][0]++;
            } else if (_recomendacion >= 7 && _recomendacion <= 8) {
              _tempNames[_temp.local_name][1]++;
            } else if (_recomendacion >= 9 && _recomendacion <= 10) {
              _tempNames[_temp.local_name][2]++;
            }
          } else {
            break;
          }
        }
        var _totalsArray = [0, 0, 0];
        for (var _key in _tempNames) {
          _this2.options.series.push({
            name: _key,
            data: _tempNames[_key]
          });
          for (var i in [0, 1, 2]) {
            _totalsArray[i] += _tempNames[_key][i];
          }
        }
        var _total = _totalsArray.reduce(function (a, b) {
          return a + b;
        }, 0);
        var NPS = (_totalsArray[2] / _total - _totalsArray[0] / _total) * 100;
        _this2.options.subtitle.text = 'NPS: ' + NPS.toFixed(2) + '%';
        _this2.disabledChart = true;
        _this2.loadingChart = false;
        _this2.$nextTick(function () {
          _this2.showChart = true;
        });
      }, function (response) {
        _this2.disabledChart = false;
        _this2.loadingChart = false;
      });
    },
    clearChart: function clearChart() {
      this.disabledChart = true;
      this.options.series = [];
      this.options.title.text = '';
      this.options.subtitle.text = '';
      this.showChart = false;
    },
    fetchLocal: function fetchLocal() {
      var _this3 = this;

      var _url = '/admin/local';
      this.$http({
        url: _url,
        method: 'GET'
      }).then(function (response) {
        var _data = response.data;
        _data.forEach(function (val) {
          _this3.locals.push({
            text: val.name,
            value: val.id + '',
            r_id: val.restaurante_id + ''
          });
        });
        _this3.$nextTick(function () {
          _this3.selectableLocals = _this3.locals;
          _this3.responseLocals = true;
        });
      }, function (response) {
        if (response.status === 401 || response.status === 403) {
          window.localStorage.removeItem('restaurante');
          window.localStorage.removeItem('local');
          window.localStorage.removeItem('role');
          window.localStorage.removeItem('uid');
          _this3.$router.go({
            name: 'sign'
          });
        }
      });
    },
    fetchRestaurant: function fetchRestaurant() {
      var _this4 = this;

      var _url = '/admin/restaurant';

      this.$http({
        url: _url,
        method: 'GET'
      }).then(function (response) {
        var _data = response.data;
        _data.forEach(function (val) {
          _this4.restaurants.push({
            text: val.name,
            value: val.id + ''
          });
        });
        _this4.$nextTick(function () {
          _this4.responseRestaurants = true;
        });
      }, function (response) {
        if (response.status === 401 || response.status === 403) {
          window.localStorage.removeItem('restaurante');
          window.localStorage.removeItem('local');
          window.localStorage.removeItem('role');
          window.localStorage.removeItem('uid');
          _this4.person = response.data;
          _this4.$router.go({
            name: 'sign'
          });
        }
      });
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"bgTransition\">\n  <template v-if=\"!responseLocals\">\n    <div class=\"preload-app\">\n      <ui-progress-linear :show=\"!responseLocals\" color=\"black\"></ui-progress-linear>\n    </div>\n  </template>\n  <template v-else=\"\">\n    <div class=\"header-section h_contact\">\n      <h2 v-if=\"titleShow\" transition=\"slideLeft\">Reporte de Satisfacción</h2>\n    </div>\n\n    <section class=\"section-chart\">\n      <template v-if=\"locals.length == 0\">\n        <ui-alert :dismissible=\"false\">No hay locales registrados.</ui-alert>\n      </template>\n      <template v-else=\"\">\n        <div class=\"width-filter col-4_filter\">\n          <div class=\"row\">\n            <div class=\"col-xs-6 col-sm-3\">\n              <date-picker label=\"Fecha de Inicio\" :value=\"born_start\" format=\"yyyy/MM/dd\" placeholder=\"DD/MM/YYYY\" input-class=\"ui-textbox-input\" language=\"es\" :disabled=\"disabledBorn\" @selected=\"onSelectedDateStart\"></date-picker>\n            </div>\n            <div class=\"col-xs-6 col-sm-3\">\n              <date-picker label=\"Fecha de Fin\" :value=\"born_end\" format=\"yyyy/MM/dd\" placeholder=\"DD/MM/YYYY\" input-class=\"ui-textbox-input\" language=\"es\" :disabled=\"disabledBorn\" @selected=\"onSelectedDateEnd\"></date-picker>\n            </div>\n            <div class=\"col-xs-6 col-sm-3\">\n              <ui-select v-if=\"flagAdmin\" name=\"level\" label=\"Restaurante(*)\" :options=\"restaurants\" placeholder=\"Seleccione una opción\" :value.sync=\"tempRestaurant\"></ui-select>\n              <ui-textbox v-if=\"!flagAdmin\" type=\"text\" name=\"restaurant\" label=\"Restaurante(*)\" :value.sync=\"setRestaurant\" disabled=\"\"></ui-textbox>\n            </div>\n            <div class=\"col-xs-6 col-sm-3\">\n              <ui-select name=\"level\" label=\"Local\" :options=\"selectableLocals\" multiple=\"\" placeholder=\"Seleccione un local\" :value.sync=\"tempLocal\"></ui-select>\n            </div>\n          </div>\n          <div class=\"text-center\" style=\"color: #fff; margin-top: 8px;\">\n            <ui-button @click=\"initChart()\" text=\"Enviar\" color=\"lanacional-primario\" :loading=\"loadingChart\" :disabled=\"!disabledChart\"></ui-button>\n          </div>\n          <ui-alert :dismissible=\"false\" :show=\"flagAlert\" type=\"warning\">Solo se mostrarán los primeros 31 días a partir de la fecha de inicio indicada</ui-alert>\n        </div>\n        <br>\n        <div class=\"width-chart\" v-if=\"showChart\">\n          <highcharts :options=\"options\" ref=\"highcharts\"></highcharts>\n          <div class=\"text-left\" style=\"color: white\">\n            <ui-select name=\"level\" label=\"Formato\" :options=\"format\" placeholder=\"Seleccione una opción\" :value.sync=\"tempFormat\" default=\"xlsx\"></ui-select>\n            <a :href=\"'/admin/stats/export_full?before='+dateEnd+'&amp;after='+dateStart+localDownloadRequestString+'&amp;format='+tempFormat.value\" download=\"\">DESCARGAR TABLA DE ENCUESTAS</a>\n          </div>\n        </div>\n      </template>\n    </section>\n  </template>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-593c572f", module.exports)
  } else {
    hotAPI.update("_v-593c572f", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}